import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import axios from "axios";
import { TextField, Button, FormControl, MenuItem } from "@mui/material";
import { AiOutlinePlus } from "react-icons/ai";
import Modal from "../Modal/Modal";
import { constants } from "../Helpers/constantsFile";
import { useSelector } from "react-redux";

const Register = (props) => {
  const types = ["Shaati", "Surwaal", "Qamiis", "Jaakad", "Futishaari"];
  const [type, setType] = useState("");
  const token = useSelector((state) => state.token.token);

  const typeHandler = (e) => {
    setType(e.target.value);
  };

  const validate = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = "Field is Required";
    }
    if (!values.username) {
      errors.username = "Field is Required";
    }
    if (!values.phone) {
      errors.phone = "Field is Required";
    }
    if (!values.usageType) {
      errors.usageType = "Field is Required";
    }
    if (values.fee != 0 && !values.fee) {
      errors.fee = "Field is Required";
    }
    return errors;
  };

  const capitalizeName = (name) => {
    return name.toUpperCase();
  };

  const formik = useFormik({
    initialValues: {
      name: props.update ? props.instance?.name : "",
      phone: props.update ? props.instance?.phone : "",
      username: props.update ? props.instance?.username : "",
      fee: props.update ? props.instance?.fee : "",
      businessNumber: props.update ? props.instance?.businessNumber : "",
      smsSuffix: props.update ? props.instance?.smsSuffix : "",
      businessLocation: props.update ? props.instance?.businessLocation : "",
      specialPassword: props.update ? props.instance?.specialPassword : "",
      usageType: props.update ? props.instance?.usageType : "",
      registrationFee: props.update ? props.instance?.registrationFee : "",
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      values.name = capitalizeName(values.name); // Capitalize the name

      if (!props.update) {
        values.password = "123";
        values.passwordConfirm = "123";
      }
      if (values.smsSuffix) {
        values.smsSuffix = `Kuna dir: *789*${values.smsSuffix}*$#`;
      }

      if (props.update) {
        axios
          .patch(`${constants.baseUrl}/${props.url}/${props.instance._id}`, values, {
            headers: {
              authorization: token,
            },
          })
          .then((res) => {
            alert("Successfully Updated");
            resetForm();
            props.hideModal();
            props.name === "User" && props.change(res?.data?.data);
          })
          .catch((err) => {
            alert(err.response?.data?.message);
          });
        props.reset();
      } else {
        axios
          .post(`${constants.baseUrl}/${props.url}`, values, {
            headers: {
              authorization: token,
            },
          })
          .then((res) => {
            alert("Successfully Created");
            props.hideModal();
            props.change(res?.data?.data);
          })
          .catch((err) => {
            alert(err.response.data.message);
          });
      }
    },
  });

  return (
    <Modal onClose={props.hideModal} pwidth={"550px"} left={props.name === "Expense" ? "32%" : "38%"} top="22%">
      <div
        style={{
          display: "flex",
          width: "550px",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        <h2>{props.update ? `${props.name} Update` : `${props.name} Creation`}</h2>

        <form
          onSubmit={formik.handleSubmit}
          style={{
            display: "flex",
            gap: "16px",
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {props.fields?.map((a, index) => (
            <div key={index}>
              <TextField
                variant="outlined"
                label={a.label}
                id={a.name}
                name={a.name}
                type={a.type}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values[a.name]}
                style={{ width: "250px", color: "black" }}
              />
              {formik.touched[a.name] && formik.errors[a.name] ? (
                <div style={{ color: "red" }}>{formik.errors[a.name]}</div>
              ) : null}
            </div>
          ))}

          <Button
            style={{
              width: "290px",
              fontSize: "16px",
              backgroundColor: "#19274B",
              color: "white",
              marginLeft: props.name === "Expense" && "200px",
            }}
            type="submit"
            variant="contained"
          >
            {props.update ? `Update ${props.name}` : `Create ${props.name}`}
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default Register;
